var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "confirm-box" }, [
    _c(
      "form",
      {
        staticClass: "confirm-box__form confirm-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "confirm-form__text" }, [
          _vm.act.send.success
            ? _c("div", [
                _vm._v(
                  "\n      Для подтверждения операции введите код из SMS\n      "
                ),
                _c("br"),
                _vm._v(
                  " Сообщение отправлено на номер " +
                    _vm._s(_vm.phone) +
                    "\n      "
                ),
                _vm.dontsend
                  ? _c("div", [_vm._v("верный код " + _vm._s(_vm.right_code))])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.act.send.success && _vm.act.send.message
            ? _c("p", [
                _vm._v(
                  "Отправить SMS не удалось: " + _vm._s(_vm.act.send.message)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.wait
          ? _c(
              "div",
              [_c(_setup.Dots, { staticClass: "confirm-box__dots" })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.povtorno
          ? _c("div", { staticClass: "confirm-form__input-box" }, [
              _c("input", {
                staticClass: "confirm-form__input",
                attrs: {
                  type: "number",
                  name: "sms-code",
                  maxlength: _vm.code_max_length,
                  readonly: _vm.wait,
                  required: "",
                },
                domProps: { value: _vm.code },
                on: { input: _vm.set_code },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.act.confirm.message
          ? _c("p", { staticClass: "confirm-form__error-text" }, [
              _vm._v(_vm._s(_vm.act.confirm.message)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "confirm-form__button confirm-form__button--reject",
            attrs: { type: "button" },
            on: { click: _vm.cancel },
          },
          [_vm._v("Отмена")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "confirm-form__timer timer" }, [
          _vm.povtorno
            ? _c("p", { staticClass: "timer__text" }, [
                _vm._v(
                  "\n      Отправить код повторно можно будет через \n      "
                ),
                _c("span", [_vm._v(_vm._s(_vm.povtorno) + " сек.")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.povtorno
            ? _c(
                "button",
                { staticClass: "timer__link", on: { click: _vm.send } },
                [_vm._v("Получить новый код")]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }